import ImageClass, * as ImageModule from './../../node_modules/ol/layer/Image.js';

// Create a wrapper class
class Image extends ImageClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in ImageModule) {
    if (key !== "default") {
        Image[key] = ImageModule[key];
    }
}

export default Image;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/layer/Image.js';